import apiClient from './apiClient';
import { mockCustomers, mockProjects } from './mockData';

// Flag to use mock data for development
const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === 'true';

/**
 * Helper function to handle errors
 * @param {object} error - Error object
 * @returns {Error} - Formatted error
 */
const handleError = (error) => {
  const message =
    error.response?.data?.error?.message ||
    error.response?.data?.message ||
    error.message;
  if (message) {
    return new Error(message);
  }
  return error;
};

// Customer Service Functions
const customerService = {
  /**
   * Get all customers available to the employee
   * @param {object} params - Filter parameters
   * @returns {Promise} - Promise containing customers
   */
  getEmployeeCustomers: async (params = {}) => {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        // Simulate network delay
        setTimeout(() => resolve(mockCustomers), 500);
      });
    }
    
    try {
      const response = await apiClient.get('/employee/customers', { params });
      return response.data.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  /**
   * Get a specific customer by ID
   * @param {string} id - Customer ID
   * @returns {Promise} - Promise containing customer
   */
  getCustomerById: async (id) => {
    if (USE_MOCK_DATA) {
      return new Promise((resolve, reject) => {
        const customer = mockCustomers.find(customer => customer.id == id);
        
        if (customer) {
          // Simulate network delay
          setTimeout(() => resolve(customer), 500);
        } else {
          setTimeout(() => reject(new Error('Customer not found')), 500);
        }
      });
    }
    
    try {
      const response = await apiClient.get(`/employee/customers/${id}`);
      return response.data.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  /**
   * Get customer projects
   * @param {string} customerId - Customer ID
   * @returns {Promise} - Promise containing customer projects
   */
  getCustomerProjects: async (customerId) => {
    if (USE_MOCK_DATA) {
      return new Promise((resolve, reject) => {
        const projects = mockProjects[customerId];
        
        if (projects) {
          // Simulate network delay
          setTimeout(() => resolve(projects), 500);
        } else {
          setTimeout(() => reject(new Error('Customer projects not found')), 500);
        }
      });
    }
    
    try {
      const response = await apiClient.get(`/employee/customers/${customerId}/projects`);
      return response.data.data;
    } catch (error) {
      throw handleError(error);
    }
  }
};

export { customerService };